import { render, staticRenderFns } from "./FormRadio.vue?vue&type=template&id=6dc0a61c&scoped=true"
import script from "./FormRadio.vue?vue&type=script&lang=js"
export * from "./FormRadio.vue?vue&type=script&lang=js"
import style0 from "./FormRadio.vue?vue&type=style&index=0&id=6dc0a61c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.103.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc0a61c",
  null
  
)

export default component.exports